import { render, staticRenderFns } from "./px-slider-card.vue?vue&type=template&id=1d26b340&scoped=true&"
import script from "./px-slider-card.vue?vue&type=script&lang=ts&"
export * from "./px-slider-card.vue?vue&type=script&lang=ts&"
import style0 from "./px-slider-card.vue?vue&type=style&index=0&id=1d26b340&lang=scss&scoped=true&"
import style1 from "./px-slider-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d26b340",
  null
  
)

export default component.exports